import React from 'react'
import { Dropdown } from 'react-bootstrap'
import {
  PrimaryButton,
  DropdownPrimaryButtonMenu,
  DropdownPrimaryButtonMenuItem,
  DropdownPrimaryButtonDivider,
} from './DropdownPrimaryButton.styles'

export interface DropdownButtonItems {
  name: string | React.ReactNode
  onClick: (e: React.MouseEvent) => void
  disabled?: boolean
  className?: string
  separatorAbove?: boolean
}

export interface DropdownButtonProps {
  id?: string
  label: string | React.ReactNode
  items: DropdownButtonItems[]
}

export const DropdownPrimaryButton = ({
  id,
  label,
  items,
}: DropdownButtonProps): JSX.Element => {
  return (
    <Dropdown>
      <Dropdown.Toggle as={PrimaryButton} id={id ?? 'dropdown-basic'}>
        {label ? label : 'Select Option'}
      </Dropdown.Toggle>

      <Dropdown.Menu as={DropdownPrimaryButtonMenu}>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {item.separatorAbove && <DropdownPrimaryButtonDivider />}
            <Dropdown.Item
              onClick={item.disabled ? undefined : item.onClick}
              as={DropdownPrimaryButtonMenuItem}
              className={item.className}
            >
              {item.name}
            </Dropdown.Item>
          </React.Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
